'use strict';

if (!window.i18n) {
    window.i18n = {};
}

if (!window.i18n.languages) {
    window.i18n.languages = {};
}

window.i18n.languages['en_US'] = {
    vistor_upsucess:"update successed",
    vistor_accountUp:"Account upgrade",
    vistor_upgradeNow:"upgrade immediately",
    vistor_dear:"Dear visitors:",
    vistor_suggest:"Hello, in order to give you a better user experience, I suggest you:",
    vistor_click:"Click \"Account Upgrade\" below to upgrade to an official account",
    vistor_sorry:"Sorry, the guest account cannot change the password. For the security of your account, please upgrade to an official account" ,

    change_useridpwd:"Confirm account and password",
    bizhong_xuanze: "Type selection",

    optional:"Optional",
    needBet: "Still need to bet:",
    needDeposit:"Still need to deposit:",

    agentCode : "Invite code",
    tips_fail:"Claim failed",

    a_stauts:"Active status",
    activityDetails_hdjxz: "Activity in progress",
    activityDetails_hdwks: "Activity not started",
    activityDetails_hdyjs: "Activity closed",

    a_time: `Activity time`,
    a_status: `Active status`,
    a_rule: `Reward rules`,
    a_content: `Activity Details`,

    gameCoin:"Game currency",

    register_chooseCurrency: "Choose deposit currency",
    register_tips0:"*Your currency cannot be changed after registration",
    register_curInstruction:"Currency description:",
    register_tips1:"1. When entering a game that does not support the user's current currency,The amount converted at the exchange rate will be brought into the game;",
    register_tips2:"2. The user's deposit/withdrawal method is to display the user's current currency support;",

    sendSuccess:"Sent successfully!",

    login_areaCode: 'country code',
    login_selectAreaCode: 'Select country or region',
    new_maxVipLV: 'congratulations! ! You are currently at the highest level',

    currency_symbol : "$",
    language : "English",

    new_r_rate: 'The amount brought into the game is the amount after the exchange rate conversion',
    new_r_rate1: 'Exchange rate：',
    new_r_money: 'Amount in the game:',
    new_r_tips6: '*Please note that the transfer to a three-party game can only bring in integers',
    new_r_tips7: 'Exchange rate reminder',
    new_r_tips8: 'I know',
    new_r_tips9: 'You are currently entering',
    new_r_game: "game",

        "ActivityNew" : {
        "btn_lingqu" : "Get",
        "btn_back" : "Back",
        "toggle_zonghe" : "All",
    },
    "SignIn":{
        "btnLingqu": "Get",
    },
    "label_text": {
        "loading_msg": "Downloading update resource bundles for you",
        "not_logged": "Not logged in",
        "password": "Password:",
        "verify": "Verification code:",
        "verify_msg": "Please enter the verification code",
        "inPlease_enter_the": "Please enter",
        "phone": "Mobile phone",
        "No": "Number",
        "determine": "Determine",
        "receive": "Receive",
        "Image_preview": "Avatar preview",
        "Install": "Install now",
        "obtain": "Congratulations on getting",
        "check_update": "Checking for updates...",
        "real_name": "Real name",
        "tips": "Resist bad games and refuse pirated games. Pay attention to self-protection and guard against being cheated. Moderate games benefit the brain, while indulging in games hurts the body. Reasonable arrangement of time, enjoy a healthy life. ",
        "title": "Get rewards",
        "tishi": "Tips",
        "no_data": "No data",
        "queding": "OK",
        "quxiao": "Cancel",
        "download_new_version": "Update version pls",
        "online_kefu": "Online",
        "save_account": "Save account",
    },
    "data_req_text": {
        "login_failure": "Login has failed. Please log in again",
    },
    "login_text": {
        "account_pro": "The account number cannot be empty, please fill in!",
        "psw_pro": "The password cannot be empty, please fill in!",
        "vfy_pro": "The verification code cannot be empty, please fill in!",
        "quick_login_fail": "Guest login failed",
        "account": "Account:",
        "account_msg": "Please enter account/phone number",
        "paw_msg": "Please enter your password",
        "Remember_acc": "Remember me",
        "forget_paw": "Forgot password?",
        "no_acc": "No account,",
        "go_reg": "Sign up >",
        "confirm_login" : "Sign in",
        "quick_login": "Guest login",
        "confirm_register" : "OK",
        "register_cg": "Sign up successful",
        "account_data": "Account information",
        "sfyz": "Authentication",
        "sfyz_tip": "Dear customer! In order to protect your account security, this login needs the following verification to prevent malicious programs from automatically logging in.",
        "bind_bank": "Please input the bound bank card",
        "bind_alipay": "Please enter the bound Alipay",
        "bank_card": "Bank card:",
        "alipay": "Alipay:",
        "code": "Verification Code:",
        "enter_bank_card": "Please input bank card number",
        "enter_alipay": "Please enter Alipay account number",
        "enter_code": "Please enter the verification code",
    },
    "register_text": {
        "perfect_suc": "Perfect the data successfully!",
        "perfect_err": "Failed to perfect the data!",
        "inp_data": "Please enter the data first!",
        "inp_email": "Please enter a Email",
        "inp_phone": "Please enter your mobile phone number",
        "inp_wx": "Please enter the WeChat id",
        "inp_qq": "Please enter QQ number",
        "email": "Email:",
        "wx_No": "WeChat:",
        "qq_No": "QQ:",
        "phone": "Mobile phone number:",
        "user_name": "User name:",
        "user_msg": "Enter a 6-12 digit letter and number account",
        "user_pro": "Password of 6-12 letter or number or symbol",
        "paw_pro": "The password is a combination of 6-12 digits and letters",
        "confirm_paw_pro": "Confirm that the password cannot be empty, please fill in!",
        "paw_consistent": "Password and confirmation password are inconsistent, please fill in again!",
        "paw_msg": "Please enter a 6-12-digit alphanumeric password",
        "confirm_msg": "Please reconfirm your password",
        "phone_msg": "Enter phone verification code",
        "con_paw": "Confirm password:",
        "exi_acc": "Existing account number,",
        "go_log": "Go to login >",
        "send_verify": "Send",
        "retry_verify": "Resend",
        "phone_confirm": "Enter the correct mobile phone number!",
        "register_suc": "Successful registration!",
        "user_not_mag": "User name cannot be empty, please fill in!",
        "No_null": "The number cannot be empty, please fill in!",
        "correct_phone": "Enter the correct mobile phone number!",
        "phone_vfy": "The mobile phone verification code cannot be empty, please fill in!",
        "loss_account": "To prevent loss of your account, please save your account",
        "account_change": "The account can only be modified once. Click Modify",
        "please_tick": "Please click the tick button to confirm the account password first!",
        "save_suc": "Save successfully!",
        "save_err": "Save failed!Please take a screenshot manually!",

        "currency": "Currency:",
        "language": "Language：",

    },
    "datum_text": {
        "datum_title": "Submission of information",
        "bank_card": "Bank card No.:",
        "inPlease_enter_the": "Please enter...",
        "input_datum": "Please enter the data first",
        "update_img": "Upload pictures",
        "select_update_img": "Please select the picture to upload",
        "limit_type": "Only JPG, JPEG, PNG can be uploaded",
        "msg_update_data": "Please upload the information first",
        "mag_update_pic": "Please upload the picture in the correct format first",
        "apply_succ": "The application was submitted successfully, please wait for approval"
    },
    "task_text": {
        "activity": "Promo",
        "task": "Task",
        "announcement": "Notice",
        "sign": "Check-in",
        "task_name": "Task title:",
        "task_detail": "Details",
        "task_time": "valid time:",
        "task_content": "content:"
    },
    "customer_text": {
        "jump_whatsapp": "whatsapp account has been copied successfully. Request to jump to whatsapp",
        "jump_telegram": "telegram account has been copied successfully. Request to jump to telegram",
        "jump_Messenger": "Messenger account has been copied successfully. Request to jump to Messenger",
        "jump_Viber": "Viber account has been copied successfully. Request to jump to Viber",
        "no_whatsapp": "Your device has not installed whatsapp",
        "no_telegram": "Your device has not installed telegram",
        "no_Messenger": "Your device has not installed Messenger",
        "no_Viber": "Your device has not installed Viber",

        "contact_customer": "Contact us",
        "not_ind_qq": "Your device does not have QQ installed",
        "jump_wx": "The WeChat account has been copied successfully. Request to jump to WeChat",
        "not_ind_wx": "Your device does not have WeChat installed",
        "jump_mt": "MT customer service account copy successfully, request to jump to MT customer service",
        "Online": "Online",
        "QQ": "QQ",
        "WECHAT": "WeChat",
        "MT": "MT",
        "CJ": "F&A",
        "contact_online": "Contact us",
        "copy_wx": "Copy WeChat number",
        "copy_mt": "Copy MT number"
    },
    "msg_text": {
        "save_date": "Save messages for up to one month",
        "message": "Message",
        "email": "Mail",
        "receive": "Received",
        "overdue": "Expired",
        "not_delete": "Can't be deleted, please receive the award first",
        "not_be_deleted": "Uncollected messages will not be deleted"
    },
    "basic_text": {
        "basic_title": "Basic information",
        "account": "Account:",
        "nickname": "Nickname:",
        "name": "Name:",
        "com_title": "Social information",
        "qq": "QQ:",
        "wx": "WeChat:",
        "phone": "Phone:",
        "email": "Email:",
    },
    "baes_text": {
        "unit": "Yuan",
        "view": "View >",
        "yes": "Yes",
        "no": "No",
        "update": "Update",
        "cancel": "Cancel",
        "mail_system": "System mail",
        "connected": "Connecting, please be patient...",
        "coin":"Gold coin",
    },
    "pre_details_text": {
        "rkz": "In the income...",
        "copy": "Copy",
        "order": "Order No.",
        "date": "Recharge time",
        "czType": "Recharge method",
        "transfer": "Transfer",
        "succ": "Success",
        "error": "Failure",
        "audit": "Under review",
        "czSucc": "Recharge failed",
        "copy_succ": "Copy successfully",
        "order_num": "Order No.",
        "detail": "Deposit details",
        "lxkf": "Contact us",
    },
    "USDT_text": {
        "second_step": "Step 2: USDT chain information",
        "url_name": "Chain name",
        "alipay": "Alipay payment",
        "url": "Chain address..."
    },
    "set_text": {
        "set_music": "Music setting",
        "switch_music": "Music switching",
        "change_d_paw": "Modify login password",
        "change_t_paw": "Modify withdrawal password",
        "version": "Version",
        "huidu": "Grayscale version",
        "swi_test": "Do you want to switch to beta?",
        "swi_hui": "Do you want to switch to grayscale?",
        "old_paw_null": "The old password cannot be empty, please fill in!",
        "new_paw_null": "The new password cannot be empty, please fill in!",
        "old_paw_limit_length": "The old password is 6-12 bits",
        "new_paw_limit_length": "The new password is a combination of 6-12 digits and letters.",
        "new_paw_limit": "The old password should be 6 digits, please fill it in again.",
        "con_paw_null": "Confirm that the password cannot be empty, please fill in!",
        "con_paw_consistent": "Password and confirmation password are inconsistent, please fill in again!",
        "new_old_paw_consistent": "The new password cannot be the same as the old password, please fill it in again!",
        "change_succ": "Congratulations, the password was changed successfully, please log in again!",
        "tx_paw_null": "Cash withdrawal password cannot be blank, please fill in",
        "con_tx_paw": "Please fill in the confirmation withdrawal password, which cannot be blank",
        "tx_paw_consistent": "The withdrawal password is inconsistent with the confirmation password, please confirm",
        "tx_paw_limit": "Cash withdrawal password should be 6 digits, please fill in again",
        "paw_change_succ": "Congratulations on your success in changing your password",
        "latest_version": "This is the latest version of App",
        "switch_server": "Switch server",
        "switch_language": "Language",
        "change_language_tips": "Take effect after restart.",
        "restart": "Restart",
    },
    "share_text": {
        "copy_wa": "Copy copy",
        "save_img": "Save picture",
        "share_py": "Share your circle of friends",
        "submit_audit": "Submit for approval",
        "copy_succ": "Copy successfully",
        "save_img_succ": "Save picture successfully",
        "save_err": "Failed to save the picture. Please go to the mobile phone settings page and open the permission to store pictures in this application.",
        "share_go": "Share to:",
        "share_err_qq": "Sharing failed, please install or check QQ and try again",
        "share_err_wx": "Sharing failed, please install or check WeChat and try again",
        "share_err_wl": "Binding failed, please check your network and try again",
        "shareIntroduce_title": "Share guide",
        "inviteFriends":"Invite friends",
    },
    "hot_text": {
        "dzyx": "Gathering the global hot video games, the popularity will not decrease, the winning rate will be higher, and tens of millions of gifts will wait for you to win!",
        "qbyx": "Gathering the global hot chess and card games, the popularity will not decrease, the winning rate will be higher, and tens of millions of gifts will wait for you to win!",
        "byyx": "Gathering the world's popular fishing games, the popularity will not decrease, the winning rate will be higher, and tens of millions of gifts will wait for you to win!",
        "rmqp": "Hot",
        "rmdz": "Hot",
        "rmby": "Hot",
        "ljyx": "Go play",
    },
    "agent_text": {
        "my_id": "My ID:",
        "under": "Yesterday's direct commission:",
        "offline": "Yesterday's offline commission:",
        "under_player": "Direct player:",
        "day_new": "Yesterday's addition:",
        "offline_player": "Offline player:",
        "bind_wx": "Bind WeChat",
        "share_rewards": "Share rewards:",
        "commission_ins": "The settlement date of the commission is daily. Sharing friends or moments can get sharing rewards!"
    },
    "vip_text": {
        "my_level": "My rank:",
        "current_code": "Current code amount:",
        "was_filed": "Promotion lottery",
        "was_filed_info": "If you advance, you will receive the lottery",
        "weeks_amounts": "Weekly gift",
        "weeks_amounts_info": "Free distribution every Monday",
        "month_amounts": "Monthly gift",
        "month_amounts_info": "Issued on time on the 1st of each month",
        "wash_code": "Code washing",
        "wash_code_info": "Maximum code washing ratio",
        "but_text": "Go immediately",
        "get_error": "Failed to get the gold coin, please refresh the gold coin again!",
        "amount_code": "Coded amount",
        "title": "My VIP",
        "backToMe":"Back",
        "me":"Me",
    },
    "xima_text": {
        "game_type": "Game type",
        "dm_total": "Effective bet amount",
        "proportion": "Maximum code washing ratio",
        "xm_amount": "Code washing amount",
        "can_led_take": "Available",
        "xm_total": "Total amount of code washing",
    },
    "PlayerCenter": {
        "note": "Comments",
        "betting_record": "Betting record",
        "trading_hours": "Trading time",
        "trading_type": "Transaction type",
        "change_amount": "Amount change",
        "balance": "Balance",
        "today": "Today",
        "yesterday": "Yesterday",
        "a_month": "One month",
        "all": "All",
        "status": "Transaction status",
        "chess": "Chess and cards",
        "send_time": "Dispatch time",
        "note_num": "Game-note number",
        "betting_amount": "Amount of bets",
        "has_been": "Awards have been awarded",
        "gaming": "Game platform",
        "jbxx": "Profile",
        "zhmx": "Amount Detail",
        "zdlb": "Bet list",
        "my_vip": "My VIP",
        "save": "Save",
        "edit": "Edit",
        "currencyType":"Convert currency",

    },
    "RechargeLayer": {
        "note": "Remarks",
        "often_play": "Quick amount played by players",
        "between": "Please enter an amount between 1 and 100",
        "gift100": "100% complimentary",
        "payment_account": "Collection account number",
        "payee": "Payee",
        "where": "Opening bank",
        "depositors": "Please fill in the real name of the depositor",
        "note_info": "Comment information",
        "step": "Step 1: Scan the collection QR code and recharge it.",
        "step2": "Step 2: Fill in your top-up information and submit the top-up",
        "session": "Recent session",
        "official": "Official certification",
        "gift2": "2% complimentary",
        "channel": "* Please select the top-up channel\ n* Please check the exchange rate carefully before selecting the channel",
        "qr_code": "Save \n the \n Q \n R \n code",
        "digital_currency": "Digital cash recharge channel 1",
        "step_1": "Step 1: Select USDT amount",
        "formula": "The calculation formula of the final recharge amount to the account: 70.86 = 10.1234USDT* current exchange rate 7 yuan",
        "step3": "Step 3: Provide withdrawal information",
        "actual_account": "Actual USDT amount received",
        "poundage": "Handling fee 0-50USDT",
        "instr": "* Please fill in strictly as shown in the left figure! \ n* If you fill in the wrong form, you will not be able to arrive on time!",
        "not_account": "Has the top-up not arrived?",
        "rate": "Exchange rate: 1USDT=99 yuan",
        "prompt_info": "Prompt information",
        "czjl": "Deposit Search",
        "czjc": "Deposit Guide",
        "ljcz": "Go",
        "czje": "Deposit amount",
        "zfpz": "Payment Voucher",
        "save_code": "Save QR",
        "xuanchuan": "Official agent recharge\n        Absolute reputation guarantee",
        "usdt_address": "USDT Deposit Address：",
        "syb": "Back",
        "complete": "Finish",
        "usdt_num": "Deposit USDT amount：",
        "go_recharge": "Go Deposit",
        "back" : "Back",
        "creat_order" : "Create Order",
        "real_usdt" : "Actual amount of USDT arrival",
        "sxf" : "Trading Fee",
        "date" : "Time",
        "state" : "Status",
        "jine" : "Amount",
        "detail" : "Detail",
        "rechargeCourse":"Deposit guide",
        "currency_symbol": "$",
        "currency_word": "USD",
        "rate2coin":"Exchange rate:1 gold coin = ",
        "get_coins":"Cash received:",
        "get_money":"Amount received:",
        "go_pay": "The copy is successful. Do you want to pay immediately?",
        "pay_now": "Pay immediately",
        "pay_not_support": "Can't make payment temporarily!",
    },
    "SettingLayer": {
        "bind_equi": "Device binding",
        "basic_info": "Basic information",
        "account": "Account:",
        "level": "Rank:",
        "set_sound": "Sound settings",
        "music": "Music",
        "sound": "Sound effect",
        "switch_music": "Music switching",
        "song2": "Love Beyond Death",
        "song1": "Song 1",
        "inp_landing_paw": "Please enter your login password",
        "inp_old_paw": "Please enter your old password",
        "old_paw": "Current pwd:",
        "inp_new_paw": "Please enter a new password",
        "new_paw": "New pwd:",
        "con_new_paw": "Confirm new password",
        "con_paw": "Confirm pwd:",
        "check_update": "Update",
        "determine": "Determine",
        "bind_shuom1": "* After binding the device, you can use guest login to directly log in to the binding device",
        "bind_shuom2": "* Automatically bind the current device by guest login in to the registered account",
        "bind_shuom3": "* After binding the device, the identity can be verified to unbind",
        "bind_shuom4": "* To verify identity, you need to enter the login password of the account",
        "bind_shuom5": "* Please use with caution!",
        "bind_shuom6": "The current device is bound",
        "bind_shuom7": "Other devices bound",
        "landing_paw": "Login password:",
        "test": "Test Environment",
        "huidu": "Gray environment",
        "standbyTest": "Alternate test environment",
        "mute_all": "Mute all",
        "change_account": "Sign out",
        "confirm_change": "OK",
        "confirm_bind": "Device binding",
        "unbind_device": "Unbind device",
        "unbind": "Unbind",
    },
    "Task": {
        "share_task": "Share the task",
        "MG_electronic": "MG electron",
        "cash": "Cash",
        "complete": "Go",
        "application": "Applying",
        "refused": "Rejected",
        "disclose_data": "Submission of information",
        "friends_account": "Friend account",
        "submit": "Submit",
        "Audit_failure": "Approval failed",
        "submit_creenshot": "Submit screenshot",
        "apply_reward": "Apply for awards",
        "first_step_pic": "Step 1: Click the icon below to share, and then take a screenshot",
        "second_step_pic": "Step 2: Submit screenshots",
        "pic_limit": "Only JPG, JPEG and PNG can be uploaded, and cannot exceed 1M",
        "pic_limit_size": "The uploaded picture size cannot exceed 1M",
        "update_pic": "Upload pictures",
        "inp_account": "Please enter your account number first",
        "video_limit_size": "The uploaded video size cannot exceed 2M",
        "first_step_video": "Step 1: Click on the icon below to share and record the video",
        "second_step_video": "Step 2: Submit video",
        "video_limit": "Only upload MP4, AVI, MOV format, can not exceed 2M",
        "update_video": "Upload video",
        "task_details": "Task details",
        "Task_details": "Task Details:",
        "task_name": "Task name:",
        "task_state": "Task description:",
        "share": "Share",
        "share_go": "Share to:",
        "submit_pic": "Submit picture",
        "submit_video": "Submit video",
        "video_update_limit": "Or upload MP4, AVI, MOV format, can not exceed 2M",
        "task_progress": "Task progress:",
        "know": "I see",
        "q_update_pic": "Please upload the picture first",
        "q_update_video": "Please upload the video first",
        "activit_Shut": "Task activity closed",
        "Qbind_wx": "Bind WeChat first",
        "Application_success": "The application was successful, please wait for approval",
        "Succ_application_Award": "Successful application for award",
        "task_ShutDown": "Sharing task closed",
        "btn_choose" : "Select",
        "editTips" : "Choose photo pls",
    },
    "ThirdGamesListLayer": {
        "xsj": "New World Chess",
        "tall_game": "A total of 1 games",
        "inp_game": "Please enter the name of the game",
    },
    "TuiGuangLayer": {
        "my_agent": "My agent",
        "agent_introduced": "Agent introduction",
        "players_query": "Player inquiry",
        "results_query": "Performance query",
        "share_task": "Share tasks",
        "rich_list": "Wealth list",
        "save_qr_code": "Save QR",
        "copy": "Copy",
        "Imm_receive": "Immediately collect",
        "share_detail": "Share details",
        "total_historical_commission": "Total historical commission:",
        "commission_available": "Can receive commission:",
        "get_record": "Record of collection",
        "date": "Date",
        "reward": "Reward",
        "query": "Query",
        "reset": "Reset",
        "inp_id": "Please enter an ID",
        "bets_today": "Today's effective betting",
        "total_bets": "Total effective bets",
        "team_num": "Number of teams",
        "directly_num": "Number of directly affiliated persons",
        "operation": "Operation",
        "details": "Details >>",
        "detailed_info": "Details",
        "under_new": "Directly added",
        "team_new": "Team added",
        "directly_under": "Direct rebate",
        "not_directly_under": "Non-direct rebate",
        "total_amount": "Total rebate",
        "account": "Account",
        "between": "Relationship",
        "effective_betting": "Valid betting/rebate amount",
        "ratio": "Ratio of rebates",
        "total": "Total",
        "task_type": "Task type",
        "share_num": "Number of shared",
        "bonus_distribution": "Distribution of awards",
        "quest_rewards": "Task awards",
        "first_invited": "First invitation",
        "to_share": "Go to sharing",
        "datum_title": "Submission of information",
        "friends_account": "Friend account",
        "submit_pic": "Submit picture",
        "submit_video": "Submit video",
        "update_pic": "Upload pictures",
        "update_video": "Upload video",
        "share": "Share",
        "ranking": "Ranking",
        "player_info": "Player information",
        "rebate_month": "This month's rebate reward",
        "rewards_month": "Share awards this month",
        "submit": "Submit",
        "tall_bets_today": "Total bets valid today:",
        "directly_num_new": "Number of directly affiliated persons (newly added):",
        "commission_payable": "Extractable commission:",
        "zhishu_renshu": "Number of directly affiliated persons:",
        "zhuce_shijian": "Registration time:",
        "jtyxtz": "Valid betting today:",
        "tdrsxz": "Number of teams (new):",
        "zyxtz": "Total effective bets:",
        "jrtdyxtz": "Today's team effective betting:",
        "zuoriyongjing": "Yesterday's commission:",
        "lishizongyong": "Total historical commission:",
        "agent_commission": "Agency commission",
        "share_commission": "Share commission",
        "title":"Promote",
        "agent_recruit": "Recruit",
        "my_id": "ID：",
        "under": "Yday's commission:",
        "offline": "Yday's Indirect commission:",
        "under_player": "First Level:",
        "day_new": "Added yday:",
        "offline_player": "Below first level:",
        "share_rewards": "Share reward:",
        "commission_ins": "Commission settlement is daily settlement, sharing to get rewards!",
        "bind_wx": "Bind Wechat",
        "historyCom": "Total commission",
        "canReceive": "Available commission",
        "contact" : "Contact us",
    },
    "WithdrawLayer": {
        "self_help": "Self-service cash withdrawal",
        "withdrawal_record": "Cash withdrawal record",
        "wallet_management": "Wallet management",
        "inp_withdrawal_amount": "Please enter withdrawal amount",
        "warm_prompt": "Warm tips",
        "current_need_adjust_amount": "Currently, <color= # 00ff00> 0 </c> flow is required before cash can be withdrawn",
        "current_need": "Currently still needed",
        "can_carry": "Flow, can withdraw cash",
        "adjust_amount": "Drag dot to adjust cash withdrawal amount",
        "bank": "Industrial and Commercial Bank of China",
        "change_bank_card": "Change bank card",
        "not_bind_card": "You have not bound your bank card for the time being, please go to bind it",
        "not_tixian_paw": "You have not set the cash withdrawal password. Please set the cash withdrawal password first",
        "tixian_paw": "Cash withdrawal password",
        "set6num_paw": "Please set a 6-digit password",
        "confirm_password": "Confirm password",
        "again_confirm_password": "Please enter your password again to confirm",
        "inp_tixian_paw": "Please enter your withdrawal password",
        "topUp_failure": "Recharge failed",
        "bank_paragraph": "Bank disbursements",
        "add_card": "Add bank card",
        "cardholder_name": "Please enter the name of the cardholder",
        "cardholder": "Cardholder:",
        "card_code": "Bank card account number:",
        "inp_bank_card_code": "Please enter your bank card number",
        "inp_bank_address": "Please enter the address of the opening bank",
        "bank_address": "Account opening address:",
        "bank_address_msg": "Tip: Please correctly select the opening bank and bind the real name. During settlement, it will be directly transferred to the changed account number. For the safety of your funds, it cannot be changed at will after binding. If you need to modify, please contact the customer service personnel.",
        "choose_bank": "Select bank:",
        "inp_aliPay_name": "Please enter the real name of Alipay",
        "inp_aliPay_code": "Please enter Alipay account number",
        "name": "Name:",
        "aliPay_account": "Alipay account:",
        "aliPay_account_msg": "Tip: Please select Alipay correctly and transfer it directly to the account number. During settlement, it will be directly transferred to the changed account number. For the safety of your funds, it cannot be changed at will after binding. If you need to modify , please contact the customer service personnel.",
        "inp_tixian_dizhi": "Please enter the withdrawal address",
        "rate": "Exchange rate",
        "daozhangUSDT": "Deposit USDT amount",
        "confirm_tixian": "Confirm",
        "max": "Max",
        "confirm_submit": "Submit",
        "tixian_time": "Withdrawal time",
        "jine": "Amount",
        "state": "Status",
        "order_info": "Order info",
        "confirm_bind": "Confirm",
        "confirm_select": "Confirm",
        "select_bank_card": "Select Bank",
        "bizhong_xuanze": "Type selection：",
        "tixian_dizhi": "Withdrawal address：",
        "more_than_0": "The withdrawal amount should be greater than 0",
    },
    "XimaLayer": {
        "selfHelp_washing": "Self-service code washing",
        "xima_record": "Code washing record",
        "xima_proportion": "Ratio",
        "fishing_game": "Fishing game",
        "to_complete": "Go",
        "receive": "Receive",
        "chess": "Chess and cards",
        "fishing": "Fishing",
        "electronic": "Electron",
        "reality": "Real person",
        "sports": "Sports",
        "eSports": "Electric competition",
        "lottery": "Lottery tickets",
        "game": "Games",
        "key_get": "One-click collection",
        "get_time": "Collection time",
        "damaliang": "Effective bet amount",
        "xima_amount": "Code washing amount",
        "details": "Details",
        "viewI": "View >>",
        "xima_details": "Details of code washing",
        "heitao_chess": "Heitao Chess and Card",
        "chess_game": "Chess and card games",
        "sports_events": "Sporting events",
        "electronic_game": "Electronic entertainment",
        "lottery_betting": "Lottery betting",
        "real_video": "Live video",
        "eSports_game": "Video game",
        "game_name": "Game name",
        "click_details": "Details",
        "tianmei_chess": "Tianmei Chess and Card",
        "detailsI": "Details>",
        "xima_range": "Code washing range",
        "vip_level": "Vip level",
        "tournament": "Electric competition event",
        "lottery_game": "Lottery game",
        "title": "Wash",
    },
    "Signal": {
        "switch": "Switch lines",
        "speed": "Line",
        "choose": "Select",
        "reconnect": "Retry",
        "helpful_hints": "Friendly tip: The lower the delay, the better the network",
        "is_msg": "This is a message",
        "in_test": "Being detected",
        "general": "General",
        "smooth": "Fluent",
        "speed1": "Extreme speed",
        "current_use": "In use",
    },
    "general": {
        "name": "Name",
        "activity": "Integrated activities",
        "xzsm": "Address publisher to get the latest installation address at any time",
        "wszl": "Perfect the data",
        "qdcj": "Sign-in lottery",
        "xtyj": "System mail",
        "xxzx": "Message center",
        "bt": "Title",
        "sj": "Time",
        "nr": "Content",
        "xx": "Message",
        "dlq": "Pending",
        "ylq": "Received",
        "ygq": "Expired",
        "ready_all": "All read",
        "del_all": "Delete all",
        "get_all": "Get all",
    },
    "EllipticalStage": {
        "musicNmae": "In order to win"
    },
    "CheckHot": {
        "update_msg": "A new version update has been detected and downloaded for you. Click to complete the update!",
        "update": "Update",
        "lack_resources": "Lack of art resources",
        "kaiyuan_chess": "Kaiyuan Chess and Card",
        "leyou_chess": "Leyou Chess and Card",
        "xinshijie_chess": "New World Chess",
        "ag_electronic": "AG electron",
        "pg_electronic": "PG electron",
        "mg_electronic": "MG electron",
    },
    "HallUI": {
        "copy_succ": "Copy successful",
        "moment_open": "Not open",
        "no_announcement": "No notice content",
        "tmpled_err": "Error, contact customer service pls",
        "game_maintain": "Game maintenance",
        "game_loading": "Game loading",
        "get_err": "Failed, pls try again!",
        "login": "Sign In",
        "register": "Sign Up",
        "copy_id": "CopyID",
        "huodong": "Promo",
        "task": "Task",
        "setting": "Setting",
        "remen": "Hot",
        "qipai": "Chess",
        "buyu": "Fishing",
        "zhenren": "Casino",
        "dianzi": "Games",
        "tiyu": "Sports",
        "caipiao": "Lottery",
        "dianjing": "Esports",
        "tuiguangdaili": "Agency",
        "xima": "Brokerage",
        "xiaoxi": "Inbox",
        "kefu": "Service",
        "xiufugongju": "Fix",
        "gengduo": "More",
        "qiandao": "Sign-in",
        "paihangbang": "Rank list ",
        "gonggao": "Notice",
        "tixian": "Withdrawal",
        "chongzhi": "Deposit",
        "xianshilingqu": "time",
        "remenyouxi": "TOP",
        "zuijingchangwan": "HISTORY",
        "play_now": "Go play",

    },
    "BasicsJS": {
        "tall": "Total",
        "minGame": "Number of games",
        "play_game": "There are no games that have been played recently",
        "editor_succ": "Edit successfully",
        "yi_bind": "Bound",
        "wu_bind": "Unbound",
        "inp_amount": "Please enter the top-up amount",
        "inp_correct_amount": "Please enter the correct top-up amount",
        "no_login_yinshang": "Silver supplier not logged in",
        "gift": "Gift",
        "voucher_cannot_empty": "Payment voucher cannot be blank",
        "pic_loading": "Picture loading",
        "amount_between": "Amount between",
        "card": "Card",
        "note_info": "Fill in the comment information to get to the account faster",
        "credit_cord": "Collection card number",
        "rate": "Exchange rate",
        "not_channel": "The top-up channel does not exist, please contact customer service",
        "select_amount": "Please select the top-up amount",
        "confirm_cancellation_order": "Are you sure to cancel the order",
        "been_submit": "The order has been submitted, please wait patiently",
        "Eventually_topUp_amount": "The final top-up amount to the account is",
        "current_rate": "Current exchange rate",
        "Outstanding_orders": "You have outstanding orders. Do you want to continue",
        "Continue": "Continue",
        "Cancel_order": "Cancel order",
        "bind_succ": "Binding successfully",
        "inp_paw": "Please enter your password first",
        "remove_bind_succ": "Unbind successfully",
        "first": "First",
        "day": "Day",
        "Sports_eSports": "Sports electronic competition",
        "directly": "Directly affiliated",
        "not_directly": "Non-directly affiliated",
        "amount_not_null": "Cash withdrawal amount cannot be blank. Please fill in",
        "WithdrawalAmount": "Cash withdrawal amount",
        "Qbind": "Bind first",
        "moment_not_bind": "You are temporarily unbound",
        "QgoBind": "Go to bind",
        "replace": "Replace",
        "between": "Between",
        "request_submit": "Cash withdrawal request submitted",
        "ContinueToCarry": "Continue to withdraw cash",
        "GiveUpWithdrawal": "Abandonment of cash withdrawal",
        "Qxuanding": "Tip: Please select correctly",
        "jiesuanshihou": "This account will be transferred directly during settlement",
        "zhuanghaowanquan": "For the safety of your funds, you cannot change it at will after binding. If you need to change it, please contact customer service personnel",
        "phoneNo": "Mobile phone number",
        "add": "Add",
        "updateTimeout": "Check update timeout, please make sure your network is normal",
        "retry": "Retry",
        "err_retry": "Error downloading file, please try again",
        "err_check_network": "Failed to download the file. Please make sure your network is normal",
        "no_get_data": "No resource updates were obtained. Please try again later",
        "network_retry": "The network has been disconnected. Please check that your network connection is normal",
        "Quit_game": "Quit",
        "ReturnHall": "Return",
        "daozhangUSDT": "USDT amount received",
    },
};
